import axios from 'axios';
import * as React from 'react';
import { useState } from 'react';
import { useApi } from '../Api/useApi';
import { GetSasUrlForUploadFragmentRequest, GetSasUrlForUploadIfcRequest, ModelRycApiClient } from '../Api/ApiServer';
import { handleBlobFileUpload } from './HandleBlobFileUpload';
import { Box, Button, Tooltip } from '@mui/material';
import { Upload } from '@mui/icons-material';
import { useParams } from 'react-router';

export interface IUploaderProps {
    ifcUploaded: (uri: string, uploadUriForFragments: string, dbModelId: number) => void;
    uploadStarted?: () => void;
    small: boolean;

}

export default function Uploader(props: IUploaderProps) {

    const { authorizedApi } = useApi(ModelRycApiClient);
    const params = useParams<{ id: string }>();


    const uploadIfcFileInChunks = async (event: any, name?: string) => {
        if (!params.id) return;
        const file = event.target.files[0];
        if (!file) return;
        props.uploadStarted?.();
        const sasUrl = await authorizedApi?.getSasUrlForUploadIfc(new GetSasUrlForUploadIfcRequest({ name: name || file.name, projectId: Number(params.id) }));
        await handleBlobFileUpload(file, sasUrl?.modelUri!);
        if (sasUrl?.id) {
            await authorizedApi?.completeIfcUpload(sasUrl.id);
            const downloadSasUrl = await authorizedApi?.getSasUrlForDownloadIfc(sasUrl.id);
            const uploadUriForFragments = await authorizedApi?.getSasUrlForUploadFragments(new GetSasUrlForUploadFragmentRequest({ id: sasUrl.id }));
            if (downloadSasUrl?.modelUri && uploadUriForFragments && uploadUriForFragments.modelUri)
                props.ifcUploaded(downloadSasUrl.modelUri, uploadUriForFragments.modelUri, sasUrl.id);
        }
    };
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    return (
        <Box>
            <Tooltip title='Nahrát IFC'>
                <Button color='secondary' sx={{
                    borderRadius: '50%',
                    minWidth: props.small ? '40px' : '56px',
                    width: props.small ? '40px' : '56px',
                    height: props.small ? '40px' : '56px',
                    padding: 0
                }} size='large' variant='contained'
                    onClick={() => fileInputRef.current?.click()}
                ><Upload /></Button>
            </Tooltip>
            <input
                ref={fileInputRef}
                type="file"
                accept='.ifc'
                style={{
                    display: 'none'
                }} onChange={(e) => { uploadIfcFileInChunks(e) }} />


        </Box>
    );
}
